import React from "react";
import {
  NavGallery,
  NavGalleryContainer,
  NavLogo,
} from "./GalleryNavbarElements";
const GalleryNavbar = () => {
  return (
    <>
      <NavGallery>
        <NavGalleryContainer>
          <NavLogo to="/">Roza Venerini</NavLogo>

          {/* <NavMenu>
            <NavItem>
              <NavLinks active={false}>Toate pozele</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks active={false}>Serbare Craciun</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks active={false}>Pasti</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks active={false}>Biserica</NavLinks>
            </NavItem>
          </NavMenu> */}
        </NavGalleryContainer>
      </NavGallery>
    </>
  );
};

export default GalleryNavbar;
